import { CommonStatusTooltip } from 'common/components/sharedCustomComponents/CommonStatusTooltip/CommonStatusTooltip';
import { EntitiesStatus } from 'common/types/Entities';
import { ColumnDefinition, ColumnType } from 'common/types/TypeDefs';

export const userMembershipColumnsDefinitionWithoutActions : ColumnDefinition[] = [
    { columnId: 'userId', columnName: 'User ID', columnType: ColumnType.First, copy: true, shouldFilterByExactMatch: true },
    { columnId: 'principalName', columnName: 'Name', columnType: ColumnType.Tooltip, copy: false },
    { columnId: 'email', columnName: 'Email', columnType: ColumnType.Tooltip, size: 1.2, copy: false },
    { columnId: 'companyKey', columnName: 'Company', columnType: ColumnType.Tooltip, size: 0.6, copy: false },
    { columnId: 'startDate', columnName: 'Start Date', columnType: ColumnType.DatetimeTooltip, size: 0.6 },
    { columnId: 'endDate', columnName: 'End Date', columnType: ColumnType.DatetimeTooltip, size: 0.6 },
    {
        columnId: 'status',
        columnName: 'Status',
        columnType: ColumnType.Chip,
        size: 90,
        copy: false,
        sortable: false,
        toolTip:  CommonStatusTooltip
    },
];

export const actionsColumnDefinition : ColumnDefinition =
    { columnId: 'actions', columnName: 'Action', columnType: ColumnType.Action, size: 0.5, sortable: false };

export const userMembershipColumnsDefinitionWithActions : ColumnDefinition[] = userMembershipColumnsDefinitionWithoutActions.concat(
    [actionsColumnDefinition]);


export const getActiveStatus = () => EntitiesStatus.ACTIVE;

export const getInactiveStatus = () => EntitiesStatus.INACTIVE;
